import styled from '@emotion/styled'

export const ModalTitle = styled.h2(
  ({ theme }) => `
  font-weight: 900;
  text-align: center;
  font-size: 16px;
  line-height: 22px;
  color: ${theme.ds.ColorBaseBlack};

  @media (max-width: 768px) {
    font-weight: 500;
  }
`
)

export const ModalContent = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin-top: 24px;
`

export const ModalActions = styled.div`
  display: flex;
  justify-content: space-between;
  align-self: flex-end;
  width: 100%;
  display: grid;
  column-gap: 16px;
  grid-template-columns: 1fr 1fr;

  @media (max-width: 768px) {
    display: flex;
    flex-direction: column-reverse;
    & button {
      margin-bottom: 16px;
    }
  }
`

export const ErrorParagraph = styled.div`
  margin: 10px 0 10px 0;
  font-size: 13px;
  text-align: center;
  color: #ff0000;
  text-transform: none;
`

export const Content = styled.div`
  @media (max-width: 768px) {
    display: flex;
    height: 100%;
    flex-direction: column;
    justify-content: center;
  }
`
